import type { TrackDef } from '../core/types';
import { CITY_TRACK } from './track-city';
import { SUBURB_TRACK } from './track-suburb';
import { LAKE_TRACK } from './track-lake';
import { HUNGARORING_TRACK } from './track-hungaroring';
import { DESERT_TRACK } from './track-desert';
import { SNOW_TRACK } from './track-snow';

/** Elérhető pályák sorrendben; az első az alapértelmezett. */
export const TRACKS: TrackDef[] = [
  CITY_TRACK,
  SUBURB_TRACK,
  LAKE_TRACK,
  HUNGARORING_TRACK,
  DESERT_TRACK,
  SNOW_TRACK,
];

export const DEFAULT_TRACK: TrackDef = CITY_TRACK;

export const trackById = (id: string | null | undefined): TrackDef =>
  TRACKS.find((t) => t.id === id) ?? DEFAULT_TRACK;
